import {
    isOrderItemGiftCard,
    isOrderItemUsedGiftCard,
} from "@@/shared/orders/order-items/is-order-item";
import type { OrderItem_V1 } from "@@/shared/orders/order-items/order-item-v1";
import type { OrderItem_V2 } from "@@/shared/orders/order-items/order-item-v2";
import type { DiscountCode } from "../codes/discount-code";
import type { Discount } from "../discount";
import { getDiscountConditionValidator } from "./get-discount-condition-validator";

//
const conditionFilter = <
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Params extends Record<string, unknown> = any,
    TOrderItem extends OrderItem_V1 | OrderItem_V2 = OrderItem_V2,
>(
    discount: Discount | DiscountCode,
    orderItems: TOrderItem[],
    params?: Params,
): TOrderItem[] => {
    const items = orderItems.filter(oi => {
        //Always fitlteres out giftcards
        if (isOrderItemGiftCard(oi)) return false;
        if (isOrderItemUsedGiftCard(oi)) return false;

        if (
            discount.conditions.every(condition => {
                const validator =
                    getDiscountConditionValidator<TOrderItem>(condition);
                const filteredItems = validator([oi], params);
                return filteredItems.length > 0;
            })
        ) {
            return true;
        }
        return false;
    });
    // const items = discount.conditions.reduce((filteredItems, condition) => {
    //     filteredItems = discountConditionValidators[condition.type](condition)(
    //         filteredItems,
    //         params
    //     );
    //     return filteredItems;
    // }, orderItems);
    return items;
};

export { conditionFilter };
